/**
 * @flow
 * @relayHash a6d253fc648114abf014b91a983f791b
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteLineItemFromCartInput = {|
  lineItemId: string
|};
export type DeleteLineItemFromCartMutationVariables = {|
  input: DeleteLineItemFromCartInput
|};
export type DeleteLineItemFromCartMutationResponse = {|
  +deleteLineItemFromCart: ?{|
    +cart: ?{|
      +additionalProducts: ?$ReadOnlyArray<?{|
        +id: string,
        +price: ?any,
        +type: ?string,
      |}>,
      +lineItems: ?$ReadOnlyArray<?{|
        +id: string,
        +product: ?{|
          +eventId: ?number,
          +price: ?any,
          +type: ?string,
        |},
        +productParams: ?{|
          +foto?: ?{|
            +sgId: ?number
          |},
          +startnumber?: ?string,
        |},
      |}>,
      +totalPrice: ?any,
    |}
  |}
|};
export type DeleteLineItemFromCartMutation = {|
  variables: DeleteLineItemFromCartMutationVariables,
  response: DeleteLineItemFromCartMutationResponse,
|};
*/


/*
mutation DeleteLineItemFromCartMutation(
  $input: DeleteLineItemFromCartInput!
) {
  deleteLineItemFromCart(input: $input) {
    cart {
      additionalProducts {
        id
        price
        type
      }
      lineItems {
        id
        product {
          eventId
          price
          type
          id
        }
        productParams {
          __typename
          ... on SingleFotoParams {
            foto {
              sgId
              id
            }
          }
          ... on FotoFlatParams {
            startnumber
          }
        }
      }
      totalPrice
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteLineItemFromCartInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "additionalProducts",
  "storageKey": null,
  "args": null,
  "concreteType": "Product",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/)
  ]
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "eventId",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sgId",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "InlineFragment",
  "type": "FotoFlatParams",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "startnumber",
      "args": null,
      "storageKey": null
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalPrice",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteLineItemFromCartMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteLineItemFromCart",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteLineItemFromCartPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "productParams",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "type": "SingleFotoParams",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "foto",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Media",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteLineItemFromCartMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "deleteLineItemFromCart",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteLineItemFromCartPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "cart",
            "storageKey": null,
            "args": null,
            "concreteType": "Cart",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "lineItems",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "product",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Product",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v2/*: any*/)
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "productParams",
                    "storageKey": null,
                    "args": null,
                    "concreteType": null,
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "type": "SingleFotoParams",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "foto",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Media",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v2/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v8/*: any*/)
                    ]
                  }
                ]
              },
              (v9/*: any*/),
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteLineItemFromCartMutation",
    "id": null,
    "text": "mutation DeleteLineItemFromCartMutation(\n  $input: DeleteLineItemFromCartInput!\n) {\n  deleteLineItemFromCart(input: $input) {\n    cart {\n      additionalProducts {\n        id\n        price\n        type\n      }\n      lineItems {\n        id\n        product {\n          eventId\n          price\n          type\n          id\n        }\n        productParams {\n          __typename\n          ... on SingleFotoParams {\n            foto {\n              sgId\n              id\n            }\n          }\n          ... on FotoFlatParams {\n            startnumber\n          }\n        }\n      }\n      totalPrice\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '57b5be934df77fe890bced5e69908fa1';

module.exports = node;
